import { sharedStyles } from '@lib/sharedStyles';
import { LitElement, css, html } from 'lit';
import { customElement } from 'lit/decorators.js';

@customElement('quiz-page')
export default class QuizPage extends LitElement {
  static readonly styles = [
    sharedStyles,
    css`
      :host {
        display: block;
        padding: 2rem;
        text-align: center;
      }

      h1 {
      }
    `
  ];

  render() {
    return html`
      <h1>The Big Bash</h1>
      <p>Quiz Application</p>
    `;
  }
}
